import { useSelector } from "react-redux";
import { getOddValue, formatOddsByBookmarkerExtend } from "@/utils/matchInfo";

function pickTrend(current, fallback) {
  if (current && current !== "unchanged") return current;
  if (fallback && fallback !== "unchanged") return fallback;
  return "unchanged";
}

function formatOdds(raw, bookmarkerExtend) {
  return formatOddsByBookmarkerExtend(raw, bookmarkerExtend || "hongkong");
}

export function useMatchOdds(match, filterOdds, companyIdOdds = -1) {
  const bookmarkerExtend = useSelector((state) => state.bookmarkerExtendReducer) || "hongkong";
  const isAllBookmaker = Number(companyIdOdds) === -1;

  const {
    filterHandicapOdds,
    filterOverUnderOdds,
    filterEuropeOdds,
    filterHandicapHalfOdds,
    filterOverUnderHalfOdds,
    filterEuropeHalfOdds,
  } = filterOdds;

  const handicapOdds = isAllBookmaker ? match.handicapOdds?.[0] : filterHandicapOdds;
  const handicapValue = getOddValue(
    filterHandicapOdds?.instantHandicap,
    isAllBookmaker ? handicapOdds?.initialHandicap : null,
  );
  const homeHandicapOdds = formatOdds(getOddValue(
    filterHandicapOdds?.instantHome,
    isAllBookmaker ? handicapOdds?.initialHome : null,
  ), bookmarkerExtend);
  const awayHandicapOdds = formatOdds(getOddValue(
    filterHandicapOdds?.instantAway,
    isAllBookmaker ? handicapOdds?.initialAway : null,
  ), bookmarkerExtend);
  const homeHandicapTrend = pickTrend(
    filterHandicapOdds?.initialHomeTrend,
    filterHandicapOdds?.initialHomeTrendOld,
  );
  const awayHandicapTrend = pickTrend(
    filterHandicapOdds?.initialAwayTrend,
    filterHandicapOdds?.initialAwayTrendOld,
  );

  const overUnderOdds = isAllBookmaker ? (match.overUnderOdds?.[0] || match.odd?.overUnderOdds?.[0]) : filterOverUnderOdds;
  const overUnderValue = getOddValue(
    filterOverUnderOdds?.instantHandicap,
    isAllBookmaker ? (overUnderOdds?.instantHandicap || "-") : null,
  );
  const overOdds = formatOdds(getOddValue(
    filterOverUnderOdds?.instantOver,
    isAllBookmaker ? overUnderValue?.instantOver : null,
  ), bookmarkerExtend);
  const underOdds = formatOdds(getOddValue(
    filterOverUnderOdds?.instantUnder,
    isAllBookmaker ? overUnderValue?.instantUnder : null,
  ), bookmarkerExtend);
  const overTrend = pickTrend(
    filterOverUnderOdds?.initialOverTrend,
    filterOverUnderOdds?.initialOverTrendOld,
  );
  const underTrend = pickTrend(
    filterOverUnderOdds?.initialUnderTrend,
    filterOverUnderOdds?.initialUnderTrendOld,
  );

  const europeOdds = getOddValue(
    filterEuropeOdds?.instantOverUnder,
    isAllBookmaker ? match.europeOdds?.[0] : null,
  );
  const homeEuropeOdds = formatOdds(getOddValue(
    filterEuropeOdds?.instantHome,
    isAllBookmaker ? europeOdds?.instantHome : null,
  ), bookmarkerExtend);
  const awayEuropeOdds = formatOdds(getOddValue(
    filterEuropeOdds?.instantAway,
    isAllBookmaker ? europeOdds?.instantAway : null,
  ), bookmarkerExtend);
  const instantDrawOdds = formatOdds(getOddValue(
    filterEuropeOdds?.instantDraw,
    isAllBookmaker ? europeOdds?.instantDraw : null,
  ), bookmarkerExtend);
  const homeEuropeTrend = pickTrend(
    filterEuropeOdds?.initialHomeTrend,
    filterEuropeOdds?.initialHomeTrendOld,
  );
  const awayEuropeTrend = pickTrend(
    filterEuropeOdds?.initialAwayTrend,
    filterEuropeOdds?.initialAwayTrendOld,
  );
  const drawTrend = pickTrend(
    filterEuropeOdds?.initialDrawTrend,
    filterEuropeOdds?.initialDrawTrendOld,
  );

  const handicapHalfOdds = isAllBookmaker ? match.handicapHalfOdds?.[0] : filterHandicapHalfOdds;
  const handicapHalfValue = getOddValue(
    filterHandicapOdds?.halfTime?.instantHandicap,
    isAllBookmaker ? handicapHalfOdds?.instantHandicap : null,
  );
  const homeHandicapHalfOdds = formatOdds(getOddValue(
    filterHandicapHalfOdds?.instantHome,
    isAllBookmaker ? handicapHalfOdds?.instantHome : null,
  ), bookmarkerExtend);
  const awayHandicapHalfOdds = formatOdds(getOddValue(
    filterHandicapHalfOdds?.instantAway,
    isAllBookmaker ? handicapHalfOdds?.initialAway : null,
  ), bookmarkerExtend);
  const homeHandicapHalfTrend = pickTrend(
    filterHandicapHalfOdds?.initialHomeTrend,
    filterHandicapHalfOdds?.initialHomeTrendOld,
  );
  const awayHandicapHalfTrend = pickTrend(
    filterHandicapHalfOdds?.initialAwayTrend,
    filterHandicapHalfOdds?.initialAwayTrendOld,
  );

  const overUnderHalfOdds = isAllBookmaker ? match.overUnderHalfOdds?.[0] : filterOverUnderHalfOdds;
  const overUnderHalfValue = getOddValue(
    filterOverUnderOdds?.halfTime?.instantHandicap,
    isAllBookmaker ? (overUnderHalfOdds?.instantHandicap || "-") : null,
  );
  const overHalfOdds = formatOdds(getOddValue(
    filterOverUnderHalfOdds?.instantOver,
    isAllBookmaker ? overUnderHalfOdds?.instantOver : null,
  ), bookmarkerExtend);
  const underHalfOdds = formatOdds(getOddValue(
    filterOverUnderHalfOdds?.instantUnder,
    isAllBookmaker ? overUnderHalfOdds?.instantUnder : null,
  ), bookmarkerExtend);
  const overHalfTrend = pickTrend(
    filterOverUnderHalfOdds?.initialOverTrend,
    filterOverUnderHalfOdds?.initialOverTrendOld,
  );
  const underHalfTrend = pickTrend(
    filterOverUnderHalfOdds?.initialUnderTrend,
    filterOverUnderHalfOdds?.initialUnderTrendOld,
  );

  const hasOverUnderHalfData =
    filterOverUnderHalfOdds?.instantOver != null ||
    filterOverUnderHalfOdds?.instantUnder != null ||
    (isAllBookmaker && overUnderHalfOdds?.instantOver != null) ||
    (isAllBookmaker && overUnderHalfOdds?.instantUnder != null);

  const europeHalfOdds = match.europeHalfOdds?.[0] || match.odd?.europeHalfOdds?.[0];
  const homeEuropeHalfOdds = getOddValue(
    filterEuropeHalfOdds?.instantHome,
    europeHalfOdds?.instantHome,
  );
  const awayEuropeHalfOdds = getOddValue(
    filterEuropeHalfOdds?.instantAway,
    europeHalfOdds?.instantAway,
  );
  const drawHalfOdds = getOddValue(
    filterEuropeHalfOdds?.instantDraw,
    europeHalfOdds?.instantDraw,
  );
  const homeEuropeHalfTrend = pickTrend(
    filterEuropeHalfOdds?.initialHomeTrend,
    filterEuropeHalfOdds?.initialHomeTrendOld,
  );
  const awayEuropeHalfTrend = pickTrend(
    filterEuropeHalfOdds?.initialAwayTrend,
    filterEuropeHalfOdds?.initialAwayTrendOld,
  );
  const drawHalfTrend = pickTrend(
    filterEuropeHalfOdds?.initialDrawTrend,
    filterEuropeHalfOdds?.initialDrawTrendOld,
  );

  return {
    handicapValue,
    homeHandicapOdds,
    awayHandicapOdds,
    homeHandicapTrend,
    awayHandicapTrend,
    overUnderValue,
    overOdds,
    underOdds,
    overTrend,
    underTrend,
    homeEuropeOdds,
    awayEuropeOdds,
    instantDrawOdds,
    homeEuropeTrend,
    awayEuropeTrend,
    drawTrend,
    handicapHalfValue,
    homeHandicapHalfOdds,
    awayHandicapHalfOdds,
    homeHandicapHalfTrend,
    awayHandicapHalfTrend,
    overUnderHalfValue,
    overHalfOdds,
    underHalfOdds,
    overHalfTrend,
    underHalfTrend,
    hasOverUnderHalfData,
    homeEuropeHalfOdds,
    awayEuropeHalfOdds,
    drawHalfOdds,
    homeEuropeHalfTrend,
    awayEuropeHalfTrend,
    drawHalfTrend,
  };
}
